import React from "react";
import TickList from "../tick-list/TickList";

const listItems = [
  "Your order delivery details in <a href='https://account.johnlewis.com/orders'>My Account</a> or your order confirmation email ",
  "If you’ve received a text or email with delivery updates",
];

function HelpWithDeliveryProblemOther() {
  return (
    <div>
      <section>
        <h2>We’re sorry there’s been a problem</h2>
        <p>Before getting in touch, you may wish to check the following:</p>
        <TickList squeezed items={listItems} />
      </section>
    </div>
  );
}

export default HelpWithDeliveryProblemOther;
